import React from "react";
import { cn } from "../../utils/cn";

/**
 * LabelValue Component
 *
 * A reusable component that displays a label and value in either vertical or horizontal layout.
 *
 * @param {string} label - The label text (required)
 * @param {React.ReactNode} value - The value content, can be text, icons, NumberFormat, etc. (required)
 * @param {string} layout - Layout direction: "vertical" (default) or "horizontal"
 * @param {string} className - Additional Tailwind classes for the container
 * @param {string} labelClassName - Additional Tailwind classes for the label
 * @param {string} valueClassName - Additional Tailwind classes for the value
 * @param {boolean} flex - Apply flex-1 to container (useful for side-by-side layouts)
 */
export const LabelValue = ({
  label,
  value,
  layout = "vertical",
  className = "",
  labelClassName = "",
  valueClassName = "",
  flex = false,
}) => {
  const isVertical = layout === "vertical";

  const containerClasses = cn(
    "flex gap-2",
    isVertical ? "flex flex-col" : "flex flex-row items-center",
    flex && "flex-1",
    className
  );

  const labelClasses = cn(
    "text-base",
    "font-bold",
    "text-[#818181]",
    "leading-[25px]",
    labelClassName
  );

  const valueClasses = cn(
    "text-[16px]",
    "text-black",
    "leading-[25px]",
    valueClassName
  );

  return (
    <div className={containerClasses}>
      <div className={labelClasses}>{label}</div>
      <div className={valueClasses}>{value}</div>
    </div>
  );
};
